// extracted by mini-css-extract-plugin
export default {"PageTitleWrapper":"fUm8CS6H"};